import { useSaveOptional } from '../contexts/WorldContext';
import { eventOpenDay } from '../utils/openDayDate';

/**
 * Open day for events of the current save (cursor D → D+1, any save type), or null outside a
 * save scope / without a cursor. Player actions are dated on this day or later.
 */
export const useOpenDay = (): string | null => {
  const save = useSaveOptional();
  return eventOpenDay(save?.cursor?.simDate || save?.cursor?.sim_date);
};
